<template>
  <section class="form-section" style="margin-bottom:0px;">
    <DxValidationGroup ref="validationGroup">
    <div>
      <dl class="form-list__row">
        <dt class="form-list__key">
          예금주명
          <span class="font-red">(필수)</span>
          <div class="div-checkedSameName">
            <DxCheckBox
              text="고객명과 동일"
              v-model="checkedSameName"
              :disabled="isRegDone"
              @valueChanged="handleCheckedSameName"
              width="100%"
            />
          </div>
        </dt>
        <dd>
          <div class="agrm-form-input-area" style="margin-bottom: 6px;">
            <DxTextBox ref="txtBox" placeholder="이름을 입력해주세요" :disabled="isRegDone || checkedSameName" v-model="params.cstmNm">
            	<DxValidator>
                  <DxRequiredRule message="이름을 입력해주세요" />
                </DxValidator>
            </DxTextBox>
          </div>
          <div v-if="!isForeigner" class="form-guide-text">
            매각자와 예금주는 동일해야합니다
          </div>
        </dd>
      </dl>
      <dl class="form-list__row">
        <dt class="form-list__key">
          입금계좌번호
          <span class="font-red">(필수)</span>
        </dt>
        <dd>
          <div style="margin-bottom: 6px;">
            <div class="agrm-form-input-area" style="margin-bottom: 8px;">
              <DxSelectBox
                placeholder="은행선택"
                displayExpr="cmnsCdNm"
                valueExpr="cmnsCd"
                :dataSource="bankCdList"
                :onClosed="() => handleSelectBoxClick(false)" 
                :onOpened="() => handleSelectBoxClick(true)"
                :disabled="isRegDone"
                name="cmnsCdSelectBox"
                id="cmnsCdSelectBox"
                v-model="params.bankCd"
              />
            </div>
            <div class="agrm-form-input-area" >
              <DxTextBox
                ref="txtBox2"
                placeholder="계좌번호를 입력해주세요 (숫자만 입력가능)"
                :disabled="isRegDone"
                v-model="om_account_value">
                <DxValidator>
                  <DxRequiredRule message="계좌번호를 입력해주세요" />
                </DxValidator>
              </DxTextBox>
            </div>
          </div>
          <div class="form-guide-text">
            본인 명의의 계좌를 입력해주세요
          </div>
        </dd>	
      </dl>
    </div>
   </DxValidationGroup>
  </section>
</template>
<script>
import DxTextBox from 'devextreme-vue/text-box'
import DxSelectBox from 'devextreme-vue/select-box'
import { DxCheckBox } from "devextreme-vue/check-box";
import DxValidationGroup from 'devextreme-vue/validation-group'
import {
  DxValidator,
  DxRequiredRule
} from 'devextreme-vue/validator'

export default {
  name: 'NewBankInfo',
  components: {
    DxCheckBox,
    DxTextBox,
    DxSelectBox,
    DxValidator,
    DxRequiredRule,
    DxValidationGroup
  },
  props: [
    'isRegDone',
    'isPassYn',
    'isForeigner',
    'orgCstmNm',
    'temp_om_account',
    'bankCdList',
    'ordInfo'
  ],
  data: () => ({
    om_account_value: '',
    params: {
      cstmNm: '',
      bankCd: '',
      cstmAccnNum: null
    },
    cstmDpstNm: '',
    checkedSameName: false
  }),
  watch: {
    temp_om_account (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.om_account_value = this.temp_om_account
      }
    },
    om_account_value (newVal, oldVal) {
      if (newVal !== oldVal) {
        const regex = /[^0-9]/g
        const result = `${newVal}`.replace(regex, '')
        this.om_account_value = result
        this.params.cstmAccnNum = result
      }
    },
    params: {
      deep: true,
      handler (newVal) {
        this.$emit('changeBankInfo', newVal)
      }
    },
    ordInfo () {
      this.params.bankCd = this.ordInfo.bankCd
      this.params.cstmNm = this.ordInfo.cstmNm
      this.cstmDpstNm = this.ordInfo.cstmDpstNm
    }
  },
  created () {
    this.om_account_value = this.temp_om_account
    this.event_value = this.temp_event
    if (this.ordInfo) {
      this.params.bankCd = this.ordInfo.bankCd
      if (this.isRegDone) {
        this.params.cstmNm = this.ordInfo.cstmDpstNm
      }
    }
  },
  mounted () {
  	this.validation()
  },
  methods: {
    handleFocus (e) {
      //const trgtHeight = e.element.offsetHeight + 90
      //window.scrollTo(0, trgtHeight)
    },
    handleFocusOut (e) {
    },
    certPass (e) {
      this.$emit('certPass')
    },
    validation (e) {
      this.$emit('validation' , this.$refs['validationGroup'], this.$refs['txtBox'] , this.$refs['txtBox2'])
    },
    handleSelectBoxClick (isOpened) {
      if (isOpened) {
        document.body.id = 'TalkDeposit'
        return
      }
      if (!isOpened && document.body.id === 'TalkDeposit') {
        document.body.id = ''
      }
    },
    handleCheckedSameName(e){
      const { value, event } = e;
      if(value){
        this.params.cstmNm = this.orgCstmNm;
      } else {
      	this.params.cstmNm = '';
      }
    }
  }
}
</script>

<style scope>
  

  @media only screen and (max-width: 1260px){
    .div-checkedSameName {
      text-align : right; 
      float : right;
    }
  }
  
  .re-style .form-section .dx-selectbox .dx-placeholder {
    font-weight: 400 !important;
    color: #000 !important;
  }
  
  .dx-widget input .dx-widget textarea {
  	font-family: "SUIT", sans-serif !important;
  }
	
  .dx-dropdownlist-popup-wrapper .dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item-content {
		background-color: #f5f5f5;
		border: 0.3px solid #e0e0e0;
		font-size: 16px;
		vertical-align: middle;
		color: #8e8e8e;
  }	
</style>


// WEBPACK FOOTER //
// src/views/purchase/sale/components/NewBankInfo.vue